const farsiSignInErrorMessages = {
  "Invalid phone number or password": "رمز عبور یا شماره موبایل اشتباه است",
  "No valid token (A)": "کد صحیح نیست"
}

export default farsiSignInErrorMessages